import { ChangeDetectorRef, InjectionToken, } from '@angular/core';
import isEqual from 'lodash-es/isEqual';
import { Subject } from 'rxjs';
var MAX_LENGTH_SUBTITLE = 70;
/**
 * Injection token used to provide the parent component to options.
 */
export var UI_SELECT_CARD_PARENT_COMPONENT = new InjectionToken('UI_SELECT_CARD_PARENT_COMPONENT');
var UiSelectCardComponent = /** @class */ (function () {
    function UiSelectCardComponent(_cd, _parent) {
        this._cd = _cd;
        this._parent = _parent;
        this.toggleSelect$ = new Subject();
        this.title = '';
        this.subtitle = '';
        this.matIcon = '';
        this.svgIcon = '';
        this.maxLengthSubtitle = MAX_LENGTH_SUBTITLE;
        this._readonly = false;
        this._disabled = false;
        this._selected = false;
    }
    Object.defineProperty(UiSelectCardComponent.prototype, "tabindex", {
        get: function () {
            return this.disabled ?
                -1 : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiSelectCardComponent.prototype, "ariaLabel", {
        get: function () {
            return this.title + ". " + this.subtitle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiSelectCardComponent.prototype, "safeSubtitle", {
        get: function () {
            return this.subtitle ?
                this.subtitle.length > this.maxLengthSubtitle ?
                    this.subtitle.slice(0, this.maxLengthSubtitle) + '...' :
                    this.subtitle : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiSelectCardComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            if (isEqual(this._value, value)) {
                return;
            }
            this._value = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiSelectCardComponent.prototype, "selected", {
        get: function () {
            return this._selected;
        },
        set: function (select) {
            if (select === this._selected) {
                return;
            }
            this._selected = select;
            this._cd.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiSelectCardComponent.prototype, "disabled", {
        get: function () {
            return !!(this._parent && this._parent.disabled) || this._disabled;
        },
        set: function (disable) {
            if (disable === this._disabled) {
                return;
            }
            this._disabled = disable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UiSelectCardComponent.prototype, "readonly", {
        get: function () {
            return !!(this._parent && this._parent.readonly) || this._readonly;
        },
        set: function (readonly) {
            if (readonly === this._readonly) {
                return;
            }
            this._readonly = readonly;
        },
        enumerable: true,
        configurable: true
    });
    UiSelectCardComponent.prototype.toggleSelect = function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.type === 'keydown') {
            return;
        }
        this.toggleSelect$.next({
            value: this.value,
            select: !this.selected,
        });
    };
    return UiSelectCardComponent;
}());
export { UiSelectCardComponent };
